// extracted by mini-css-extract-plugin
export var borderRadius = "_dm-4";
export var large = "_dm-3";
export var logoContainer = "_dm-0";
export var nameLogo = "_dm-2";
export var small = "_dm-1";